// extracted by mini-css-extract-plugin
export default {"small-text":"small-text-883d"};